import { useState, type FormEvent } from "react";
import { useAuth } from "../auth";
import { BrandMark } from "../components/Logo";
import lockupWhite from "../images/insight-bw-white.png";

const EyeIcon = (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
const EyeOffIcon = (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10 10 0 0 1 12 20C5 20 1 12 1 12a18 18 0 0 1 5.06-5.94M9.9 4.24A9 9 0 0 1 12 4c7 0 11 8 11 8a18 18 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

export function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await login(email, password);
      // SPA-login navigerer ikke, så be nettleseren lagre passordet eksplisitt
      // (Credential Management API — Chromium; Safari/Firefox bruker form-heuristikken).
      try {
        const PC = (window as unknown as { PasswordCredential?: new (d: { id: string; password: string }) => Credential }).PasswordCredential;
        if (PC && navigator.credentials?.store) {
          await navigator.credentials.store(new PC({ id: email, password }));
        }
      } catch {
        /* lagring er best-effort */
      }
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Innlogging feilet");
      setBusy(false);
    }
  }

  return (
    <div className="login-scene">
      <div className="login-brandpanel">
        <BrandMark size={720} className="login-watermark" />
        <img className="login-lockup login-rise" src={lockupWhite} alt="betaworks insight" />
      </div>

      <div className="login-formcol">
        <div className="login-stack">
          <img className="login-lockup-mobile login-rise" src={lockupWhite} alt="betaworks insight" />

          <div className="login-tabs login-rise" style={{ animationDelay: "0.06s" }}>
            <span className="login-tab on">Logg inn</span>
          </div>

          <form className="login-card login-rise" style={{ animationDelay: "0.12s" }} onSubmit={onSubmit}>
            <label className="login-label">
              E-post
              <input
                className="login-input"
                type="email"
                name="email"
                autoComplete="username"
                autoFocus
                disabled={busy}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </label>

            <label className="login-label">
              Passord
              <div className="login-pw">
                <input
                  className="login-input"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  autoComplete="current-password"
                  disabled={busy}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="login-pw-toggle"
                  tabIndex={-1}
                  aria-label={showPassword ? "Skjul passord" : "Vis passord"}
                  onClick={() => setShowPassword((v) => !v)}
                >
                  {showPassword ? EyeOffIcon : EyeIcon}
                </button>
              </div>
            </label>

            {err && <div className="login-error">{err}</div>}

            <button className="login-primary" type="submit" disabled={busy}>
              {busy ? "Logger inn …" : "Logg inn"}
            </button>
          </form>

          <p className="login-foot login-rise" style={{ animationDelay: "0.2s" }}>© Betaworks</p>
        </div>
      </div>
    </div>
  );
}
